import { render, staticRenderFns } from "./GuardTasks.vue?vue&type=template&id=6baeae13&"
import script from "./GuardTasks.vue?vue&type=script&lang=ts&"
export * from "./GuardTasks.vue?vue&type=script&lang=ts&"
import style0 from "./GuardTasks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports